import React from 'react';
import PropTypes from 'prop-types';

// components
import ZoneCollectionLayer from './ZoneCollectionLayer';

// utils
import { styleMethods } from 'dataviz/config/map';

/** A map layer for displaying manual generated zones */
const GeneratedZonesLayer = ({
  map,
  rowHover,
  zones
}) => {
  // binding with no context is a bit strange but keeping same paradigm as ScenarioLayer
  return (
    <section className='vra-scenario-layer'>
      <ZoneCollectionLayer
        layerName='generated-zones'
        map={map}
        styleFunction={styleMethods.generatedZones.bind(null, rowHover)}
        zones={zones}
      />
    </section>
  );
};

GeneratedZonesLayer.propTypes = {
  map: PropTypes.object, // Inserted by mapping/leaflet.
  rowHover: PropTypes.string,
  zones: PropTypes.array.isRequired
};

export default GeneratedZonesLayer;
